import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';

const ConfirmCloseModal = ({ isOpen, toggle, onConfirm, title, message }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered={true} size="sm">
      <ModalBody className="py-3 px-4">
        <div className="mt-2 text-center">
          <div className="mt-2 pt-2 fs-15 mx-2">
            <h5>{title}</h5>
            <p className="text-muted mb-0">{message}</p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="d-flex gap-2 justify-content-center w-100">
          <button
            type="button"
            className="btn btn-light"
            onClick={toggle}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={onConfirm}
          >
            Cerrar
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

ConfirmCloseModal.defaultProps = {
  title: '¿Está seguro que desea cerrar?',
  message: 'Los cambios no guardados se perderán.',
};

ConfirmCloseModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
};

export default ConfirmCloseModal;
